// contexts/AuthContext.jsx - Authentication Context
import React, { createContext, useState, useEffect, useContext } from 'react';
import authService from '../services/authService';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [currentTenant, setCurrentTenant] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Check authentication status on mount
  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    try {
      setLoading(true);
      setError(null);
      const tenant = await authService.me();
      setCurrentTenant(tenant);
    } catch (err) {
      setCurrentTenant(null);
      if (err.message !== 'Not authenticated') {
        setError(err.message);
      }
    } finally {
      setLoading(false);
    }
  };

  const login = () => {
    authService.login();
  };

  const logout = async () => {
    try {
      await authService.logout();
      setCurrentTenant(null);
      window.location.href = '/';
    } catch (err) {
      setError(err.message);
    }
  };

  const value = {
    currentTenant,
    isAuthenticated: !!currentTenant,
    loading,
    error,
    login,
    logout,
    checkAuth
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}
